<template>
<mds-section collapsible title="Filters" bold border="none" container expanded :size="6"
:class="{ 'filter-container-with-margin' : dispayWithMargin }"
>
  <div class="filter-bar">
    <div class="filter-bar__container-server">
      <div class="inputs-section" v-if="!hideFilters.dateRange">
        <strong>Refresh Data by:</strong>
        <div class="mds-popover__wrapper">
          <div class="filters-date-range-bar">
            <mds-date-picker
              :value="startDate"
              :name="startDate"
              :min-max-dates="minMaxDates"
              label="Start Date"
              placeholder="Select Start Date"
              @input="updateStartDate"
            ></mds-date-picker>
            <mds-date-picker
              v-model="endDate"
              :name="endDate"
              :min-max-dates="minMaxDates"
              :disable-dates="disableDates"
              :disabled="!enableEndDate"
              @input="updateEndDate"
              label="End Date"
              placeholder="Select End Date"
            ></mds-date-picker>
          </div>
        </div>
        <div
          v-if="selectedFilters.dateRange.startDate || selectedFilters.dateRange.endDate"
          class="filter-bar__tag-group noPadBottomLeft"
        >
          <div class="mds-tag-group">
            <filter-item
              v-if="selectedFilters.dateRange.startDate"
              type="Start Date"
              :label="formatDate(selectedFilters.dateRange.startDate)"
              :key="`startdate-${selectedFilters.dateRange.startDate}`"
              @closeItem="removeFilter($event, 'startDate')"
            />
            <filter-item
              v-if="selectedFilters.dateRange.endDate"
              type="End Date"
              :label="formatDate(selectedFilters.dateRange.endDate)"
              :key="`enddate-${selectedFilters.dateRange.endDate}`"
              @closeItem="removeFilter($event, 'endDate')"
            />
            <button
              v-if="selectedFilters.dateRange.startDate || selectedFilters.dateRange.endDate"
              class="mds-button mds-button--flat clear-all-btn leftMargin"
              type="button"
              @click="clearDateFilter()"
            >
              Clear all
            </button>
          </div>
        </div>
        <!-- eslint-disable max-len -->
        <p class="note">{{ `[ Note: ${note} ]` }}</p>
      </div>
    </div>
    <div class="filter-bar__container-client">
      <div class="inputs-section">
        <strong>Filter by:</strong>
        <template v-if="!hideFilters.products">
          <simple-lineup-product-list
            :optionsList="availableProducts"
            title="All Products"
            subtitle="Products"
            :disabled="!localPolicyOptions.options.filter"
            v-if="selectedClient > 0 && isGridLineup"
            @clickItem="updateProduct"
          />
          <simple-list
            :optionsList="availableProducts"
            title="All Products"
            subtitle="Products"
            :disabled="!localPolicyOptions.options.filter"
            v-if="selectedClient > 0 && !isGridLineup"
            @clickItem="updateProduct"
            @removeSelection="removeProduct"
          />
        </template>
        <template v-if="!hideFilters.classes">
          <multi-list
            @updateSelectedList="updateSelectedFilter('assets', ...arguments)"
            @updateInvertedSelectedList="updateInvertedFilter('assets', ...arguments)"
            @toggleSelectAll="toggleSelectAll('assets', ...arguments)"
            :optionsList="availableFilters.assets"
            :selectedOptions="selectedFilters.assets"
            title="All Asset Classes"
            subtitle="Asset Classes"
            :allSelected="allFilters.assets"
            :disabled="!localPolicyOptions.options.filter"
          />
        </template>
        <template v-if="!hideFilters.categories">
          <multi-list
            @updateSelectedList="updateSelectedFilter('categories', ...arguments)"
            @updateInvertedSelectedList="updateInvertedFilter('categories', ...arguments)"
            @toggleSelectAll="toggleSelectAll('categories', ...arguments)"
            :optionsList="availableFilters.categories"
            :selectedOptions="selectedFilters.categories"
            title="All Categories"
            subtitle="Categories"
            :allSelected="allFilters.categories"
            :disabled="!localPolicyOptions.options.filter"
          />
        </template>
        <template v-if="!hideFilters.statuses">
          <multi-list
            @updateSelectedList="updateSelectedFilter('status', ...arguments)"
            @updateInvertedSelectedList="updateInvertedFilter('status', ...arguments)"
            @toggleSelectAll="toggleSelectAll('status', ...arguments)"
            :optionsList="availableFilters.status"
            :selectedOptions="selectedFilters.status"
            title="All Statuses"
            subtitle="Statuses"
            :allSelected="allFilters.status"
            :disabled="!localPolicyOptions.options.filter"
          />
        </template>
        <template v-if="!hideFilters.updates">
          <multi-list
            @updateSelectedList="updateSelectedFilter('updates', ...arguments)"
            @updateInvertedSelectedList="updateInvertedFilter('updates', ...arguments)"
            @toggleSelectAll="toggleSelectAll('updates', ...arguments)"
            :optionsList="availableFilters.updates"
            :selectedOptions="selectedFilters.updates"
            title="All Updates"
            subtitle="Updates"
            :allSelected="allFilters.updates"
            :disabled="!localPolicyOptions.options.filter"
          />
        </template>
        <template v-if="!hideFilters.reviewStatuses">
          <multi-list
            @updateSelectedList="updateSelectedFilter('reviewStatus', ...arguments)"
            @updateInvertedSelectedList="updateInvertedFilter('reviewStatus', ...arguments)"
            @toggleSelectAll="toggleSelectAll('reviewStatus', ...arguments)"
            :optionsList="availableFilters.reviewStatus"
            :selectedOptions="selectedFilters.reviewStatus"
            title="All Review Statuses"
            subtitle="Review Statuses"
            :allSelected="allFilters.reviewStatus"
            :disabled="!localPolicyOptions.options.filter"
          />
        </template>
      </div>
      <div class="downlad-section" v-if="isFundsExportEnabled">
        <export-funds-report-menu />
      </div>
    </div>
    <div class="filter-bar__tag-group" v-if="showTagGroup">
      <div class="mds-tag-group">
        <filter-item
          v-for="item in selectedProducts"
          :label="item"
          type="Product"
          :key="`product-${item}`"
          @closeItem="removeProduct"
        />
        <filter-item
          v-for="item in selectedFilters.assets"
          :label="item"
          type="Asset Class"
          :key="`asset-${item}`"
          @closeItem="removeFilter($event, 'assets')"
        />
        <filter-item
          v-for="item in selectedFilters.categories"
          type="Category"
          :label="item"
          :key="`category-${item}`"
          @closeItem="removeFilter($event, 'categories')"
        />
        <filter-item
          v-for="item in selectedFilters.status"
          type="Status"
          :label="item"
          :key="`status-${item}`"
          @closeItem="removeFilter($event, 'status')"
        />
        <filter-item
          v-for="item in selectedFilters.updates"
          type="Updates"
          :label="item"
          :key="`updates-${item}`"
          @closeItem="removeFilter($event, 'updates')"
        />
        <filter-item
          v-for="item in selectedFilters.reviewStatus"
          type="Review Status"
          :label="item"
          :key="`reviewStatus-${item}`"
          @closeItem="removeFilter($event, 'reviewStatus')"
        />
        <button
          class="mds-button mds-button--flat clear-all-btn"
          type="button"
          @click="removeAllFilters()"
        >
          Clear all
        </button>
      </div>
    </div>
  </div>
</mds-section>
</template>
<script>
import { get, sortBy } from 'lodash';
import { mapState } from 'vuex';
import { reviewErrorFromResponse, goToLogoutRoute } from '@/utils';
import FilterItem from '@/components/atoms/FilterItem';
import MultiList from '@/components/molecules/MultiList';
import SimpleList from '@/components/molecules/SimpleList';
import SimpleLineupProductList from '@/components/molecules/SimpleLineupProductList';
import ExportFundsReportMenu from '@/components/molecules/ExportFundsReportMenu';
import { getFundCategoriesByFiduciary, getFundCategoriesByClient } from '@/services/Categories';
import { getProductsOfFiduciaryClient, getLineupProductsOfFiduciaryClient } from '@/services/FiduciaryClients';
import MdsDatePicker from '@mds/date-picker';
import MdsSection from '@mds/section';

export default {
  name: 'filterBar',
  components: {
    'multi-list': MultiList,
    'simple-list': SimpleList,
    'simple-lineup-product-list': SimpleLineupProductList,
    'filter-item': FilterItem,
    'export-funds-report-menu': ExportFundsReportMenu,
    MdsDatePicker,
    MdsSection,
  },
  props: {
    client: {
      type: Number,
      required: true,
    },
    fiduciary: {
      type: Number,
      required: true,
    },
    hideFilters: {
      type: Object,
      default() {
        return {
          products: false,
          classes: false,
          categories: false,
          statuses: false,
          updates: true,
          dateRange: true,
          reviewStatuses: true,
        };
      },
    },
    clearAll: {
      type: Boolean,
      default: false,
    },
    isGridLineup: {
      type: Boolean,
      default: false,
    },
    dispayWithMargin: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      availableFilters: {
        assets: [],
        categories: [],
        reviewStatus: [
          {
            label: 'Review completed',
            value: 'Review completed',
          },
          {
            label: 'Requested for review',
            value: 'Requested for review',
          },
          {
            label: 'Unreviewed',
            value: 'Unreviewed',
          },
        ],
      },
      availableProducts: [],
      selectedProducts: [],
      selectedStatus: [],
      selectedCategory: [],
      selectedAsset: [],
      selectedUpdates: [],
      selectedFilters: {
        assets: [],
        categories: [],
        status: [],
        updates: [],
        dateRange: {
          startDate: '',
          endDate: '',
        },
        reviewStatus: [],
      },
      allFilters: {
        assets: false,
        categories: false,
        status: false,
        updates: false,
        reviewStatus: false,
      },
      startDate: '',
      endDate: '',
      minMaxDates: {
        min: new Date(2015, 0, 1),
        max: this.getTomorrow(),
      },
      disableDates: () => false,
      /* eslint-disable max-len */
      note: 'The above action will clear all below filters, if anything selected, and fetch new data from the server of the given date range.',
    };
  },
  computed: {
    ...mapState({
      policies: (state) => state.user.policies,
      investmentReports: (state) => state.system.config.investmentReports,
      selectedClient: (state) => state.grid.client.selected,
      selectedClientName: (state) => state.grid.client.name,
      selectedProduct: (state) => state.grid.product.selected,
      selectedProductName: (state) => state.grid.product.name,
      selectedFiduciary: (state) => state.user.fiduciary,
      selectedTab: (state) => state.grid.tab,
    }),
    enableEndDate() {
      return !!this.selectedFilters.dateRange.startDate;
    },
    currentViewName() {
      return this.selectedClient > 0 ? 'one-client' : 'all-clients';
    },
    localPolicyOptions() {
      // Tabs are applied to 1 Client View
      if (this.currentViewName === 'all-clients') {
        return get(this.policies, `grid.views.${this.currentViewName}`);
      }
      return get(this.policies, `grid.views.${this.currentViewName}.tabs.${this.selectedTab}`);
    },
    showTagGroup() {
      return (
        this.selectedFilters.assets.length > 0
        || this.selectedFilters.categories.length > 0
        || this.selectedFilters.status.length > 0
        || this.selectedFilters.updates.length > 0
        || this.selectedFilters.reviewStatus.length > 0
        || this.selectedProducts.length > 0
      );
    },
    isOneClientView() {
      return this.selectedClient !== 0 && this.selectedClientName !== 'All Clients';
    },
    isFundsExportEnabled() {
      return this.investmentReports.availableFiduciaries.includes(this.selectedFiduciary.code) && !this.isOneClientView;
    },
  },
  created() {
    this.updateFilterOptions();
    if (this.selectedClient > 0) {
      this.updateProductOptions();
    }
  },
  methods: {
    getTomorrow() {
      const tomorrow = new Date();
      return new Date(tomorrow.getFullYear(), tomorrow.getMonth(), tomorrow.getDate());
    },
    checkValidDate(date) {
      return (!!date && typeof date.getTime === 'function' && date.toString() !== 'Invalid Date');
    },
    updateStartDate(value) {
      this.startDate = value;
      this.endDate = '';
      this.disableDates = this.checkValidDate(value) ? (date) => date.getTime() < value.getTime() : () => false;
    },
    updateEndDate(value) {
      this.endDate = value;
    },
    formatDate(dateValue) {
      return new Date(dateValue).toLocaleString('en-us', { day: 'numeric', month: 'short', year: 'numeric' });
    },
    getProductData() {
      getProductsOfFiduciaryClient({
        selectedClient: this.client,
      }).then((result) => {
        reviewErrorFromResponse(result);
        if (result.status.success) {
          this.availableProducts = result.data.filter(
            (product) => product.fiduciaryClient.fiduciary.id === this.fiduciary,
          );
          this.sortProducts();
        }
      }).catch((error) => {
        this.handleError(error);
      });
    },
    handleError(error) {
      const httpStatus = (error?.response?.status) ? (error?.response.status) : error?.status;
      if (httpStatus === 401) {
        goToLogoutRoute(this.$route, this.$router);
      }
    },
    sortProducts() {
      this.availableProducts = this.availableProducts.sort((a, b) => {
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        }
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        }
        return 0;
      });
    },
    getLineupProductData() {
      getLineupProductsOfFiduciaryClient({
        selectedClient: this.client,
      }).then((result) => {
        reviewErrorFromResponse(result);
        if (result.status.success) {
          this.availableProducts = result.data;
          this.sortProducts();
        }
      }).catch((error) => {
        this.handleError(error);
      });
    },
    updateProductOptions() {
      if (this.isGridLineup) {
        this.getLineupProductData();
      } else {
        this.getProductData();
      }
    },
    updateFilterOptions() {
      this.selectedFilters.assets = [];
      this.selectedFilters.categories = [];
      this.selectedFilters.status = [];
      this.allFilters.assets = false;
      this.allFilters.categories = false;
      this.allFilters.status = false;
      this.allFilters.reviewStatus = false;
      this.$emit('updateFilters', this.selectedFilters, false);

      this.availableFilters.updates = [
        {
          label: 'Added',
          value: 'Added',
        },
        {
          label: 'Deleted',
          value: 'Deleted',
        },
      ];

      if (this.client === 0) {
        this.availableFilters.status = [
          {
            label: 'Approved',
            value: 'Approved',
          },
          {
            label: 'On Watch',
            value: 'OnWatch',
          },
          {
            label: 'Removed',
            value: 'Removed',
          },
        ];

        getFundCategoriesByFiduciary({
          selectedFiduciary: this.fiduciary,
        }).then((result) => {
          reviewErrorFromResponse(result);
          if (result.status.success) {
            const assets = [...new Set(result.data.map((item) => item.broadAssetClassName))];
            const categories = [...new Set(result.data.map((item) => item.name))];
            this.availableFilters.assets = assets.map((item) => ({
              label: item,
              value: item,
            }));
            this.availableFilters.categories = categories.map((item) => ({
              label: item,
              value: item,
            }));
            this.availableFilters.assets = sortBy(this.availableFilters.assets, ['label']);
            this.availableFilters.categories = sortBy(this.availableFilters.categories, [
              'label',
            ]);
          }
        }).catch((error) => {
          const httpStatus = (error?.response.status) ? (error?.response.status) : error?.status;
          if (httpStatus === 401) {
            goToLogoutRoute(this.$route, this.$router);
          }
        });
      } else {
        this.availableFilters.status = [
          {
            label: 'Approved',
            value: 'Approved',
          },
          {
            label: 'None',
            value: 'None',
          },
          {
            label: 'On Watch',
            value: 'OnWatch',
          },
          {
            label: 'Removed',
            value: 'Removed',
          },
        ];

        getFundCategoriesByClient({
          selectedClient: this.client,
        }).then((result) => {
          reviewErrorFromResponse(result);
          if (result.status.success) {
            const assets = [...new Set(result.data.map((item) => item.broadAssetClassName))];
            const categories = [...new Set(result.data.map((item) => item.name))];
            this.availableFilters.assets = assets.map((item) => ({
              label: item,
              value: item,
            }));
            this.availableFilters.categories = categories.map((item) => ({
              label: item,
              value: item,
            }));
            this.availableFilters.assets = sortBy(this.availableFilters.assets, ['label']);
            this.availableFilters.categories = sortBy(this.availableFilters.categories, [
              'label',
            ]);
          }
        }).catch((error) => {
          const httpStatus = (error?.response?.status) ? (error?.response.status) : error?.status;
          if (httpStatus === 401) {
            goToLogoutRoute(this.$route, this.$router);
          }
        });
      }
    },
    updateSelectedFilter(type, add, value) {
      if (add) {
        if (value === '') {
          this.selectedFilters[type] = [];
        } else {
          this.selectedFilters[type].push(value);
        }
        this.$emit('updateFilters', this.selectedFilters, false);
      } else {
        this.removeFilter(value, type);
      }

      if (type === 'status') {
        this.selectedStatus = [...this.selectedFilters[type]];
      } else if (type === 'categories') {
        this.selectedCategory = [...this.selectedFilters[type]];
      } else if (type === 'assets') {
        this.selectedAsset = [...this.selectedFilters[type]];
      } else if (type === 'updates') {
        this.selectedUpdates = [...this.selectedFilters[type]];
      }
    },
    updateInvertedFilter(type, remove, value) {
      this.selectedFilters[type] = [];
      this.allFilters[type] = false;
      this.availableFilters[type].map((item) => {
        if (item.value !== value) {
          this.selectedFilters[type].push(item.value);
        }
        this.$emit('updateFilters', this.selectedFilters, false);
        return item;
      });
    },
    removeFilter(value, type) {
      if (type === 'startDate' || type === 'endDate') {
        this[type] = '';
        this.selectedFilters.dateRange[type] = '';
      } else {
        const filterIndex = this.selectedFilters[type].indexOf(value);
        if (filterIndex > -1) {
          this.selectedFilters[type].splice(filterIndex, 1);
        }
      }
    },
    removeProduct() {
      this.selectedProducts = [];
      this.$emit('updateProductFunds', 0, 'All Products', 'Universe');
    },
    removeAllFilters() {
      this.selectedFilters.assets = [];
      this.toggleSelectAll('assets', false);
      this.selectedFilters.categories = [];
      this.toggleSelectAll('categories', false);
      this.selectedFilters.status = [];
      this.toggleSelectAll('status', false);
      this.selectedFilters.updates = [];
      this.toggleSelectAll('updates', false);
      this.selectedFilters.reviewStatus = [];
      this.toggleSelectAll('reviewStatus', false);
      this.removeProduct();
    },
    clearClientFilters() {
      this.selectedFilters.assets = [];
      this.toggleSelectAll('assets', false);
      this.selectedFilters.categories = [];
      this.toggleSelectAll('categories', false);
      this.selectedFilters.status = [];
      this.toggleSelectAll('status', false);
      this.selectedFilters.updates = [];
      this.toggleSelectAll('updates', false);
      this.selectedFilters.reviewStatus = [];
      this.toggleSelectAll('reviewStatus', false);
      this.removeProduct();
      this.$emit('updateFilters', this.selectedFilters, false);
    },
    clearDateFilter() {
      this.startDate = '';
      this.endDate = '';
      this.selectedFilters.dateRange.startDate = '';
      this.selectedFilters.dateRange.endDate = '';
      this.$emit('updateFilters', this.selectedFilters, false);
    },
    toggleSelectAll(type, active) {
      if (active) {
        /*
         * For Status filter needs to be explicit because Status == None is not
         * included by default when no filter are applied
         * MIMPSA-4354
         */
        if (type === 'status') {
          this.selectedFilters[type] = this.availableFilters[type].map((s) => s.value);
        } else {
          this.selectedFilters[type] = [];
        }
        this.allFilters[type] = true;
      } else {
        this.selectedStatus = [];
        this.selectedCategory = [];
        this.selectedAsset = [];
        this.allFilters[type] = false;
        this.selectedFilters[type] = [];
      }
      this.$emit('updateFilters', this.selectedFilters, this.allFilters.status);
    },
    updateProduct(product) {
      this.selectedProducts = [`${product.name} (${product.code})`];
      this.$store.dispatch('setProduct', {
        code: product.code,
        listVisible: false,
        name: product.name,
        selected: product.id,
      });
      if (this.isGridLineup) {
        this.$emit('updateProductFunds', product, product.name, product.code);
      }
    },
  },
  watch: {
    startDate(value) {
      this.clearClientFilters();
      this.selectedFilters.dateRange.startDate = value;
      this.selectedFilters.dateRange.endDate = '';
      this.$emit('updateFilters', this.selectedFilters, false);
      this.$emit('updateDateFilters', this.selectedFilters);
    },
    endDate(value) {
      this.selectedFilters.dateRange.endDate = value;
      this.$emit('updateFilters', this.selectedFilters, false);
      this.$emit('updateDateFilters', this.selectedFilters);
    },
    client() {
      this.updateFilterOptions();
      this.removeProduct();
      if (this.selectedClient > 0) {
        this.updateProductOptions();
      }
    },
    selectedStatus() {
      this.$emit('updateStatusFilter', this.selectedStatus);
    },
    selectedCategory() {
      this.$emit('updateCategoryFilter', this.selectedCategory);
    },
    selectedAsset() {
      this.$emit('updateAssetFilter', this.selectedAsset);
    },
    selectedUpdates() {
      this.$emit('updateUpdatesFilter', this.selectedUpdates);
    },
    clearAll: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue === true) {
          this.removeProduct();
          this.removeAllFilters();
        }
      },
    },
  },
};
</script>
<style lang="scss">
.filter-container-with-margin {
  margin: $mds-space-2-x $mds-space-2-x 0 $mds-space-2-x;
}
.filters-date-range-bar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-left: $mds-space-2-x;

  .mds-date-picker___connect {
    top: -$mds-space-3-x;
  }

  .note {
    font-size: 9px;
  }
}
.leftMargin {
  margin-left: $mds-space-2-x;
}
.filter-bar__tag-group.noPadBottomLeft {
  padding-bottom: 0;
  padding-left: 0;
}
.mds-date-picker___connect .mds-date-picker__container___connect {
  z-index: 300 !important; //override mds
}
.filter-bar {
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  position: relative;
  width: 100%;
  &__container-server {
    display: flex;
    justify-content: space-between;
    .inputs-section {
      padding: 0 $mds-space-inset-2-x $mds-space-inset-2-x $mds-space-inset-2-x;
    }
  }
  &__container-client {
    display: flex;
    justify-content: space-between;
    .inputs-section {
      padding: 0 $mds-space-inset-2-x $mds-space-inset-2-x $mds-space-inset-2-x;
      @include mds-body-text-m();
      strong {
        font-weight: $mds-font-weight-bold;
        padding-right: $mds-space-inset-2-x;
      }
    }
    .downlad-section {
      padding: 0 $mds-space-inset-4-x $mds-space-inset-2-x $mds-space-inset-4-x;
      @include mds-body-text-m();
    }
  }
  &__message {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-content: flex-start;
  }
  &__tag-group {
    padding: 0 $mds-space-2-x $mds-space-1-x $mds-space-4-x;
    margin-top: 0;

    .clear-all-btn {
      margin-left: $mds-space-2-x;
    }
  }
}
</style>
